import React from "react";
import Icon from "antd/lib/icon";

const HashConcept = props => {
  const columnStyle = {
    display: "flex",
    flexDirection: "column",
    marginBottom: "10px"
  };

  const blockText = {
    fontSize: "10pt",
    marginLeft: "5px"
  };

  return (
    <div>
      <p className="step-p">A hash looks like a bunch of random numbers and letters. </p>

      <p className="step-p">
        It is a alphanumeric value that uniquely identifies data, or the "digital
        fingerprint" of data.
      </p>

      <span>Properties of a hash:</span>
      <div style={columnStyle}>
        <div>
          <Icon type="minus"/>
          <span style={blockText}>Hash has a fixed length.</span>
        </div>
        <div>
          <Icon type="barcode"/>
          <span style={blockText}>Same data always maps to same hash.</span>
        </div>
        <div>
          <Icon type="qrcode"/>
          <span style={blockText}>Different data always maps to a different hash (within practical limitations).</span>
        </div>
        <div>
          <Icon type="calculator"/>
          <span style={blockText}>Is easy to compute.</span>
        </div>
        <div>
          <Icon type="lock"/>
          <span style={blockText}>Is infeasible to convert hash to data.</span>
        </div>
        <div>
          <Icon type="arrow-up"/>
          <span style={blockText}>A small change in data leads to a large change in hash.</span>
        </div>
      </div>
    </div>
  );
};

export default HashConcept;



// WEBPACK FOOTER //
// ./src/steps/hash/hash-concept.js